import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const SocialProofSection = () => {
  const [activeTab, setActiveTab] = useState('whatsapp');

  const whatsappReviews = [
    {
      id: 1,
      name: "Rohit M.",
      time: "2:45 PM",
      message: "Just received my ₹85,000 winning amount! Thank you Nitin team for the quick payout 🎉",
      reply: "Congratulations Rohit! We\'re thrilled to be part of your winning journey. Keep playing and winning! 🏆",
      status: "delivered"
    },
    {
      id: 2,
      name: "Sneha K.",
      time: "11:30 AM",
      message: "The customer support is amazing! Got help within 2 minutes on WhatsApp. Very professional team 👍",
      reply: "Thank you Sneha! Our team is always here to help you 24/7. Happy gaming! 😊",
      status: "read"
    },
    {
      id: 3,
      name: "Vikash P.",
      time: "Yesterday",
      message: "Won ₹1,20,000 in Teen Patti! Money credited in 15 minutes. Best platform ever! 💰",
      reply: "Fantastic win Vikash! We\'re proud to have winners like you. Keep the winning streak going! 🚀",
      status: "delivered"
    }
  ];

  const socialReviews = [
    {
      id: 1,
      platform: "google",
      name: "Arjun Reddy",
      rating: 5,
      date: "2 days ago",
      review: "Excellent platform with genuine payouts. Won ₹75,000 last week and received payment within 20 minutes. Customer service through WhatsApp is outstanding!",
      likes: 24,
      verified: true
    },
    {
      id: 2,
      platform: "facebook",
      name: "Kavya Sharma",
      rating: 5,
      date: "5 days ago",
      review: "Been playing for 6 months now. Multiple wins, always paid on time. The WhatsApp support team is very helpful and professional. Highly recommended!",
      likes: 18,
      verified: true
    },
    {
      id: 3,
      platform: "google",
      name: "Manoj Kumar",
      rating: 5,
      date: "1 week ago",
      review: "Started with ₹5000, now I've won over ₹2 lakhs! The platform is completely trustworthy. Love the instant WhatsApp support feature.",
      likes: 31,
      verified: true
    }
  ];

  const tabs = [
    { id: 'whatsapp', name: 'WhatsApp Reviews', icon: 'MessageCircle', count: whatsappReviews?.length },
    { id: 'social', name: 'Social Media', icon: 'Share2', count: socialReviews?.length }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name="Star"
        size={14}
        color={index < rating ? "#FFD700" : "#E5E5E7"}
        className={index < rating ? "fill-current" : ""}
      />
    ));
  };

  const handleShareReview = (review) => {
    const message = `Check out this amazing review about Nitin Online Hub: "${review?.message || review?.review}" - ${review?.name}. Join this trusted gaming platform!`;
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section className="py-16 bg-surface-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-gradient-royal mb-4">
            Real Reviews from Real Winners
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            See what our community is saying about their winning experience with Nitin Online Hub
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="flex justify-center mb-8">
          <div className="bg-card rounded-card p-1 shadow-subtle">
            {tabs?.map((tab) => (
              <button
                key={tab?.id}
                onClick={() => setActiveTab(tab?.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-button text-sm font-medium transition-royal ${
                  activeTab === tab?.id
                    ? 'bg-primary text-primary-foreground shadow-royal'
                    : 'text-text-secondary hover:text-primary hover:bg-muted'
                }`}
              >
                <Icon name={tab?.icon} size={16} />
                <span>{tab?.name}</span>
                <span className="bg-primary/20 text-primary px-2 py-1 rounded-full text-xs">
                  {tab?.count}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* WhatsApp Reviews */}
        {activeTab === 'whatsapp' && (
          <div className="max-w-4xl mx-auto space-y-6">
            {whatsappReviews?.map((review) => (
              <div key={review?.id} className="bg-card rounded-card shadow-subtle p-6">
                {/* Chat Header */}
                <div className="flex items-center justify-between mb-4 pb-4 border-b border-border">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-success rounded-full flex items-center justify-center">
                      <Icon name="MessageCircle" size={20} color="white" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-text-primary">{review?.name}</h4>
                      <p className="text-sm text-text-secondary">WhatsApp Chat</p>
                    </div>
                  </div>
                  <div className="text-sm text-text-secondary">{review?.time}</div>
                </div>

                {/* Customer Message */}
                <div className="mb-4">
                  <div className="bg-muted rounded-card p-4 max-w-md ml-auto">
                    <p className="text-text-primary">{review?.message}</p>
                    <div className="flex items-center justify-end space-x-1 mt-2">
                      <span className="text-xs text-text-secondary">{review?.time}</span>
                      <Icon 
                        name="Check" 
                        size={12} 
                        color={review?.status === 'read' ? "var(--color-primary)" : "var(--color-text-secondary)"} 
                      />
                      <Icon 
                        name="Check" 
                        size={12} 
                        color={review?.status === 'read' ? "var(--color-primary)" : "var(--color-text-secondary)"} 
                        className="-ml-1"
                      />
                    </div>
                  </div>
                </div>

                {/* Nitin Reply */}
                <div className="mb-4">
                  <div className="bg-primary/10 border-l-4 border-primary rounded-card p-4 max-w-md">
                    <div className="flex items-center space-x-2 mb-2">
                      <div className="w-6 h-6 bg-gradient-royal rounded-full flex items-center justify-center">
                        <Icon name="Crown" size={12} color="white" />
                      </div>
                      <span className="text-sm font-semibold text-primary">Nitin Support</span>
                    </div>
                    <p className="text-text-primary">{review?.reply}</p>
                  </div>
                </div>

                {/* Actions */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4 text-sm text-text-secondary">
                    <div className="flex items-center space-x-1">
                      <Icon name="Shield" size={14} color="var(--color-success)" />
                      <span>Verified Chat</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Icon name="Clock" size={14} />
                      <span>Real-time Support</span>
                    </div>
                  </div>
                  
                  <button
                    onClick={() => handleShareReview(review)}
                    className="flex items-center space-x-1 text-primary hover:text-primary/80 transition-royal"
                  >
                    <Icon name="Share" size={14} />
                    <span className="text-sm font-medium">Share</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Social Media Reviews */}
        {activeTab === 'social' && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {socialReviews?.map((review) => (
              <div key={review?.id} className="bg-card rounded-card shadow-subtle hover:shadow-royal transition-royal p-6">
                {/* Review Header */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-gradient-royal rounded-full flex items-center justify-center">
                      <Icon name="User" size={20} color="white" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-text-primary">{review?.name}</h4>
                      {review?.verified && (
                        <div className="flex items-center space-x-1">
                          <Icon name="CheckCircle" size={12} color="var(--color-success)" />
                          <span className="text-xs text-success">Verified</span>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-1">
                    <Icon name={review?.platform === 'google' ? 'Search' : 'Facebook'} size={16} />
                    <span className="text-sm text-text-secondary capitalize">{review?.platform}</span>
                  </div>
                </div>

                {/* Rating */}
                <div className="flex items-center space-x-2 mb-4">
                  <div className="flex space-x-1">
                    {renderStars(review?.rating)}
                  </div>
                  <span className="text-sm font-medium text-text-primary">{review?.rating}/5</span>
                  <span className="text-sm text-text-secondary">• {review?.date}</span>
                </div>

                {/* Review Content */}
                <blockquote className="text-text-primary leading-relaxed mb-4">
                  "{review?.review}"
                </blockquote>

                {/* Footer */}
                <div className="flex items-center justify-between pt-4 border-t border-border">
                  <div className="flex items-center space-x-1 text-sm text-text-secondary">
                    <Icon name="ThumbsUp" size={14} />
                    <span>{review?.likes} helpful</span>
                  </div>
                  
                  <button
                    onClick={() => handleShareReview(review)}
                    className="flex items-center space-x-1 text-primary hover:text-primary/80 transition-royal"
                  >
                    <Icon name="Share" size={14} />
                    <span className="text-sm font-medium">Share</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* CTA */}
        <div className="text-center mt-12">
          <div className="bg-gradient-royal rounded-card p-8 text-white max-w-2xl mx-auto">
            <h3 className="text-2xl font-heading font-bold mb-4">
              Join Our Community of Winners
            </h3>
            <p className="text-lg opacity-90 mb-6">
              Experience the same exceptional service and winning opportunities
            </p>
            <button
              onClick={() => {
                const message = "Hi! I've seen the amazing reviews and I want to join Nitin Online Hub. Can you help me get started?";
                window.open(`https://wa.me/917704070169?text=${encodeURIComponent(message)}`, '_blank');
              }}
              className="bg-white text-primary hover:bg-gray-100 px-8 py-3 rounded-button font-semibold transition-royal flex items-center space-x-2 mx-auto"
            >
              <Icon name="MessageCircle" size={20} />
              <span>Start Your Journey</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;